export const conversionFields = [
  "home_for",
  "home_against",
  "away_for",
  "away_against",
];
const valid = (row) =>
  conversionFields.every((k) => Number.isFinite(row?.[k]) && row[k] > 0);
// Immutable season anchor. Never reinterpret today's learned team value as last season.
export function conversionSeasonPolicy(state, id, preserve = false) {
  if(!state)return null;
  const season = Number(state.current_season_id || state.season_id),
    team = state.teams?.[id],
    old = team?.conversion_season_policy;
  if (
    old?.season_id === season &&
    valid(old.original) &&
    valid(old.reference)
  ) {
    return {
      ...old,
      preserve,
      baseline: Object.fromEntries(
        conversionFields.map((k) => [
          k,
          preserve
            ? old.original[k]
            : 0.7 * old.reference[k] + 0.3 * old.original[k],
        ])
      ),
    };
  }
  const initialization = state.initializations?.[season],
    initial = initialization?.teams_after_normalization;
  const original = initial?.[id]?.conversion;
  const ids=state.active_team_ids || Object.keys(initial || {});
  const rows = ids.map(id=>initial?.[id]?.conversion);
  const reference =
    rows.length && rows.every(valid)
      ? Object.fromEntries(
          conversionFields.map((k) => [
            k,
            rows.reduce((s, r) => s + r[k], 0) / rows.length,
          ])
        )
      : null;
  if (!valid(original) || !valid(reference)) return null;
  return {
    version: 1,
    season_id: season,
    preserve,
    source: "season_initialization",
    original: { ...original },
    reference,
    baseline: Object.fromEntries(
      conversionFields.map((k) => [
        k,
        preserve ? original[k] : 0.7 * reference[k] + 0.3 * original[k],
      ])
    ),
  };
}
